import 'css/desktop/blog-list.scss';

import 'js/desktop/common/common.jquery.js';
